//import * as Helper from "../../../../utils/Helper";
import ApiService from "../../../../ApiService";

const EditService = {
    loadScreenView: (id, successCallback, failureCallback) => {
        ApiService.post("/web/admin/class/student/edit/loadscreenview", { id }, successCallback, failureCallback);
    },
    saveStudent: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/class/student/edit/save", vo, successCallback, failureCallback);
    },
    saveStudentNew: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/class/student/edit/savenew", vo, successCallback, failureCallback);
    },
    savePassword: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/class/student/edit/savepassword", vo, successCallback, failureCallback);
    }
};

export default EditService;